var _g, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberTag1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_43_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 5.28595 0 2.92893 1.46447 1.46447C2.92893 0 5.28595 0 10 0H29C37.381 0 41.5715 0 44.9223 1.23617C50.4116 3.26125 54.7387 7.58844 56.7638 13.0777C58 16.4285 58 20.619 58 29V29C58 37.381 58 41.5715 56.7638 44.9223C54.7387 50.4116 50.4116 54.7387 44.9223 56.7638C41.5715 58 37.381 58 29 58H10C5.28595 58 2.92893 58 1.46447 56.5355C0 55.0711 0 52.714 0 48V10Z",
    fill: "#FFBC0B"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.0227,
    cy: 10.5,
    rx: 7.60186,
    ry: 2.95423,
    transform: "rotate(31.6062 46.0227 10.5)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59448,
    cy: 51.5551,
    rx: 4.07411,
    ry: 2.17568,
    transform: "rotate(22.2251 6.59448 51.5551)",
    fill: "white",
    fillOpacity: 0.91
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_43_35",
    x: 0,
    y: 0,
    width: 58,
    height: 63.5172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.51724
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823215 0 0 0 0 0.598454 0 0 0 0 0.00468252 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_35"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_43_35",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTag1);
export default __webpack_public_path__ + "static/media/numberTag1.4f244e0b35853910644a35d1b2636454.svg";
export { ForwardRef as ReactComponent };